import React, { useState } from "react";
import {
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import NestedRowCell from "./NestedRowCell";
// import NestedRowCell from "./NewNestedRowCell";

const NestedRow = (props) => {
  const {
    columns,
    config,
    index,
    rows,
    commonStyle,
    helperFunction,
    errorRef,
  } = props;
  const { renderRows, needNestedActions = true } = config;

  const [_, forceRender] = useState({});
  const render = () => forceRender({});

  renderRows.rows[index] = render;

  const isViewMode = !!rows[index]?.submitted || !!config.isViewMode;
  const isSubmitted = !!rows[index]?.submitted;

  const renderStaticRow = (
    columns,
    rowData = {},
    mainRowIndex = null,
    path = [],
    allColumns
  ) => {
    const isLast = columns.find((col) => col?.type === "nested");
    const finalIndex = columns.length - 1;

    return columns.map((column, idx) => {
      const currentPath = [...path, column.uniqueName];

      if (column.type === "nested") {
        const nestedRows = rowData[column.uniqueName] || [];

        return (
          <React.Fragment key={column.uniqueName + idx}>
            {!config.isViewMode && needNestedActions && (
              <TableCell
                sx={{
                  ...commonStyle.tableCell,
                  ...(column?.sx ? { ...column?.sx } : {}),
                }}
              >
                <NestedRowCell
                  column={column}
                  row={rowData}
                  mainRowIndex={mainRowIndex}
                  isAction={true}
                  isFinalAction={false}
                  isMainFinalAction={false}
                  idx={idx}
                  config={{
                    ...config,
                    columns,
                    rows,
                    isViewMode,
                  }}
                  helperFunction={helperFunction}
                  path={currentPath}
                  allColumns={allColumns}
                  errorRef={errorRef}
                />
              </TableCell>
            )}
            <TableCell>
              <Table size="small">
                <TableBody sx={{ padding: "0px" }}>
                  {nestedRows.length > 0 ? (
                    nestedRows.map((nestedRow, i) => (
                      <TableRow key={i} sx={{ ...commonStyle.tableRow }}>
                        {renderStaticRow(
                          column.value,
                          nestedRow,
                          mainRowIndex,
                          [...currentPath, i],
                          allColumns
                        )}
                      </TableRow>
                    ))
                  ) : (
                    <TableRow sx={{ ...commonStyle.tableRow }}>
                      <TableCell colSpan={column.value.length}>
                        <Typography variant="body2" color="text.secondary">
                          No data
                        </Typography>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableCell>
          </React.Fragment>
        );
      } else {
        return (
          <React.Fragment key={column.uniqueName + idx}>
            <TableCell
              sx={{
                ...commonStyle.tableCell,
                ...(column?.sx ? { ...column?.sx } : {}),
              }}
            >
              <NestedRowCell
                column={column}
                row={rowData}
                mainRowIndex={mainRowIndex}
                config={{
                  ...config,
                  columns,
                  rows,
                  isViewMode,
                }}
                helperFunction={helperFunction}
                path={currentPath}
                allColumns={allColumns}
                errorRef={errorRef}
              />
            </TableCell>
            {!isLast &&
              finalIndex === idx &&
              !config.isViewMode &&
              needNestedActions && (
                <TableCell sx={{ ...commonStyle?.tableCell }}>
                  <NestedRowCell
                    column={column}
                    row={rowData}
                    mainRowIndex={mainRowIndex}
                    isAction={true}
                    isFinalAction={true}
                    isMainFinalAction={false}
                    config={{
                      ...config,
                      columns,
                      rows,
                      isViewMode,
                    }}
                    helperFunction={helperFunction}
                    path={currentPath}
                    allColumns={allColumns}
                  />
                </TableCell>
              )}
          </React.Fragment>
        );
      }
    });
  };

  return (
    <>
      <TableRow key={index} sx={{ ...commonStyle.tableRow }}>
        {renderStaticRow(columns, rows[index], index, [index], columns)}

        {/* Show Actions cell only when explicitly needed */}
        {(needNestedActions && !config.isViewMode) ||
        (!needNestedActions &&
          config?.alwaysShowActions &&
          config?.actions?.length > 0) ? (
          <TableCell sx={{ ...commonStyle?.tableCell }}>
            {needNestedActions ? (
              <NestedRowCell
                column={columns}
                row={rows[index]}
                mainRowIndex={index}
                isAction={true}
                isFinalAction={true}
                isMainFinalAction={true}
                isCustomAction={true}
                config={{
                  ...config,
                  columns,
                  rows,
                  isViewMode,
                }}
                helperFunction={helperFunction}
                path={[index]}
                allColumns={columns}
              />
            ) : (
              config?.actions?.map((action, actionIndex) => (
                <Tooltip title={action.tooltip || ""} key={actionIndex}>
                  <IconButton
                    size="small"
                    color={action.color || "default"}
                    onClick={() => action.onClick?.(rows[index], index)}
                  >
                    {action.icon}
                  </IconButton>
                </Tooltip>
              ))
            )}
          </TableCell>
        ) : null}
      </TableRow>
    </>
  );
};

export default NestedRow;
